import { render } from "./Single.vue?vue&type=template&id=fadd906c"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__